import React, { Component } from "react";
import { Divider, Grid } from "@material-ui/core";

export default class Spacer extends Component {
    render() {
        const isGrid = this.props.grid || true;

        if (isGrid) {
            return (
                <Grid item xs={12} className="divider">
                    <Divider />
                </Grid>
            )
        } else {
            return (
                <Divider />
            )
        }
    }
}
